import React, { useEffect } from "react";
import "./servicePage.scss";
import ServiceImage from "../../../assets/images/service.png";
import ProviderSection from "./providerSection";
import IhreVorteile from "./ihreVorteile";
import VerkaufenSection from "./verkaufenSection";
import ServiceImageSection from "./serviceImageSection";
import { NavLink } from "react-router-dom";
export default function ServicePage() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      <div className="service-page-content-alignment">
        <div className="container-md-2">
          <div className="grid">
            <div className="grid-items">
              <div className="text-grid animate__fadeInLeft animate__animated">
                <div className="text-grid-items">
                  <div className="divider"></div>
                </div>
                <div className="text-grid-items">
                  <h1>Property Management Service</h1>
                </div>
              </div>
              <p className="animate__fadeInUp animate__animated">
                Auch im Außendienst für Ihre Wohn- oder Gewerbeimmobilie
                unterstützen wir Sie gern. So sparen Sie nachhaltig Fixkosten
                und erhöhen Ihre eigene Flexibilität.
              </p>
              <div className="outline-primary-button">
                <NavLink to="/kontakt">
                  <button>Kontakt aufnehmen</button>
                </NavLink>
              </div>
            </div>
            <div className="grid-items">
              <div className="service-image-style">
                <NavLink to="/kontakt">
                  <img
                    className="animate__backInUp animate__animated wow"
                    src={ServiceImage}
                    alt="ServiceImage"
                  />
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ProviderSection />
      <IhreVorteile />
      <VerkaufenSection />
      <ServiceImageSection />
    </>
  );
}
